import { Component } from "../../core/Component";
import IMask from "imask";
const TYPE_POLICY = {
  12: {
    name: "Text",
    validationNameFn: "validationText",
    icon: ""
  },
  15: {
    name: "Phone",
    validationNameFn: "validationPhone",
    icon: "qform_icon-phone"
  },
  18: {
    name: "Email",
    validationNameFn: "validationEmail",
    icon: "qform_icon-email"
  },
  19: {
    name: "Number",
    validationNameFn: "validationNumber",
    icon: ""
  }
};
export class UniversalComponent extends Component {
  // static className = "qform-row";
  constructor($root, options) {
    super($root, options);
    /* if(typeof options.classes === "string" && options.classes.length > 0) {
      $root.$el.classList.add(`wrap-${options.classes}`)
    } */
    this.fieldId = options.id;
    this.messages = options.messages;
    this.typeId = options.typeId;
    this.typeIcon = {
      0: "",
      1: "qform_icon-user",
      2: "qform_icon-user",
      3: "qform_icon-address"
    };
    this.text_field_type_id = options.textFieldTypeId || 0;
    this.label = options.label || "";
    this.hint = options.hint || "";
    this.require = options.required === 1;
    this.maxLength = options.maxLength;
    this.placeholder = options.placeholder || "";
    this.classes = options.classes || "";
    // установка пользовательских классов оформления
    // this.setUserClasses()
    this.name = `${options.name}`;
    this.id = `${options.formId}_${options.formIndex}_${options.name}_${new Date().getTime()}`;
    this.boxId = `${options.name}_${options.formIndex}_box_${new Date().getTime()}`;
    this.boxIdField = `${options.name}_${options.formIndex}_box-field_${new Date().getTime()}`;
    this.boxIdInput = `${options.name}_${options.formIndex}_box-input_${new Date().getTime()}`;
    this.errorBox = `${options.name}_${options.formIndex}_error-box_${new Date().getTime()}`;
    this.errorBoxText = `${options.name}_${options.formIndex}_error-box_text_${new Date().getTime()}`;
    this.labelId = `${options.name}_${options.formIndex}_label_${new Date().getTime()}`;

    // For phone
    this.mask_use = options.useMask || false;
    this.mask = options.mask;

    // For number
    this.precision = options.precision || 8;
    this.wrapClasses = this.makeWrapUserClasses();
    this.saveInStorage = this.options.data.saveInStorage;
  }
  toHTML() {
    return `
    <div class="qform-field ${this.hint ? "qform-hint" : ""} ${this.typeId === 12 ? this.typeIcon[this.text_field_type_id] : TYPE_POLICY[this.typeId].icon} ${this.wrapClasses?.join(" ") || ""}"
    id="${this.boxId}">
      <div class="qform-field_wrap">
      ${this.toHtmlOutLabelBox()}
      <div class="qform-field__block">
        ${this.toHtmlAttBox("out_left")}
          <div class="qform-field__block_box">
            <div class="qform-field__block_box__field" id="${this.boxIdField}">
              ${this.toHtmlAttBox("in_left")}
              <div class="qform-field__block_box__field-box" id="${this.boxIdInput}">
                <input
                  class="${["qform-field__block_box__field-box_input", !!this.mask_use ? "maskField" : "", this.classes].join(" ").trim()}"
                  type="text"
                  id="${this.id}"
                  name="${this.name}"
                  placeholder="${this.placeholder.replace(/"/g, "&quot;")}"
                  ${this.require ? "required" : ""}
                  data-mask="${this.mask}"
                  ${this.maxLength ? `maxlength="${this.maxLength}"` : ""}
                >
                ${this.options.useDesign ? `<label for="${this.id}" class="qform-field__block_box__field-box_label">
                        ${this.label}
                        <span class="qform-field__importance-label">(${this.messages.unrequired})</span>
                      </label>` : ""}
              </div>
              ${this.toHtmlAttBox("in_right")}
            </div>
          </div>
          ${this.toHtmlAttBox("out_right")}
        </div>
      </div>
      ${this.toHtmlBottomBox()}
    </div>
    `;
  }
  init() {
    let {
      disable = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    /**
     * @type HTMLInputElement
     * */
    this.$input = this.$root.$el.querySelector(`#${this.id}`);
    this.$input.disabled = disable;
    this.$box = this.$root.$el.querySelector(`#${this.boxId}`);
    this.$boxField = this.$root.$el.querySelector(`#${this.boxIdField}`);
    this.$boxInput = this.$root.$el.querySelector(`#${this.boxIdInput}`);
    // this.$errorBox = this.$root.$el.querySelector(`#${this.errorBox}`);
    this.$errorBoxText = this.$root.$el.querySelector(`#${this.errorBoxText}`);
    this.listeners = [{
      eventName: "paste",
      method: "onPaste",
      el: this.$input
    }];
    const items = JSON.parse(localStorage.getItem(this.options.formId));
    if (items !== null) {
      items[this.$input.name] = items[this.$input.name] ?? "";
      this.$input.value = items[this.$input.name];
      localStorage.setItem(this.options.formId, JSON.stringify(items));
    }
    switch (this.typeId) {
      // Phone
      case 15:
        this.$input.type = "text";
        this.$input.inputMode = "tel";
        this.listeners.push({
          eventName: "input",
          method: "maskTelephoneInput",
          el: this.$input
        });
        if (this.mask_use) {
          const mask = phoneNumber => {
            return phoneNumber.replace(/\{([^}]*)}/g, (match, group) => {
              return `{${group.replace(/0/g, "\\0")}}`;
            });
          };
          this.iMask = IMask(this.$input, {
            mask: mask(this.mask)
          });
        }
        break;
      // Email
      case 18:
        this.$input.type = "email";
        break;
      // Number
      case 19:
        this.$input.type = "number";
        this.$input.min = this.options.min;
        this.$input.max = this.options.max;
        break;
    }
    this.listeners = [...this.listeners, {
      eventName: "input",
      method: "onInput",
      el: this.$input
    }, {
      eventName: "change",
      method: "onChange",
      el: this.$input
    }, {
      eventName: "focus",
      method: "onFocus",
      el: this.$input
    }, {
      eventName: "blur",
      method: "onBlur",
      el: this.$input
    }, {
      eventName: "click",
      method: "focusInput",
      el: this.$boxInput
    }];
    super.init();
  }
  onInput(event) {
    event.preventDefault();
    this.validation();
    if (this.saveInStorage) {
      let storage = JSON.parse(localStorage.getItem(this.options.formId));
      if (storage) {
        storage[this.$input.name] = this.iMask?.unmaskedValue || this.$input.value;
      }
      localStorage.setItem(this.options.formId, JSON.stringify(storage));
    }
    this.$emit("Change:field", this.$input.value);
  }
  onChange() {
    this.validation();
    if (this.saveInStorage) {
      let storage = JSON.parse(localStorage.getItem(this.options.formId));
      if (storage) {
        storage[this.$input.name] = this.iMask?.unmaskedValue || this.$input.value;
      }
      localStorage.setItem(this.options.formId, JSON.stringify(storage));
    }
  }
  onFocus() {
    this.$boxField.classList.add("qform-field-focus");
  }
  onBlur() {
    this.$boxField.classList.remove("qform-field-focus");
    this.validation();
  }
  focusInput() {
    this.$input.focus();
  }
  maskTelephoneInput(event) {
    if (event.inputType !== "deleteContentForward" && !this.iMask) {
      const input = event.target;
      input.value = input.value.replace(/\D/g, "");
    }
  }
  setClassField(data) {
    if (data && typeof data.formStyleFieldRequired !== "undefined") {
      if (data.formStyleFieldRequired.type === 0 && this.require) {
        this.$box.classList.add("required");
      } else if (data.formStyleFieldRequired.type === 1 && !this.require) {
        this.$box.classList.add("not-required");
      }
      if (!data.formStyleFieldRequired.useDesign) {
        this.$box.classList.remove("required");
        this.$box.classList.remove("not-required");
      }
    }
  }

  /**
   * @param str {String} */
  mutationPhone(str) {
    return str.replace(/[^+\d]/g, "");
  }
  getValue() {
    let values = [];
    if (this.$input.value.trim().length > 0) {
      if (this.typeId === 15) {
        values.push(this.mutationPhone(this.$input.value.trim()));
      } else if (this.typeId === 19) {
        values.push(this.$input.value.trim().replace(",", "."));
      } else {
        values.push(this.$input.value.trim());
      }
    }
    return {
      id: this.fieldId,
      name: this.name,
      typeId: this.typeId,
      values: values
    };
  }
  validationText() {
    let setMassageValid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let valid = true;
    if (this.require && this.$input.value.trim().length === 0) {
      setMassageValid ? this.setMassageValid(this.messages.inputRequired) : null;
      valid = false;
      //ограничение на java - 3584 для текстовых полей
    } else if (this.$input.value.trim().length > 3584) {
      valid = false;
      setMassageValid ? this.setMassageValid(this.messages.inputTextTooLong) : null;
    } else {
      this.setMassageValid();
    }
    return valid;
  }
  validationEmail() {
    let setMassageValid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let valid = true;
    let re = /[-.\w]+@([\w-]+\.)+[\w-]+/g;
    if (this.require && this.$input.value.length === 0) {
      setMassageValid ? this.setMassageValid(this.messages.inputRequired) : null;
      valid = false;
    } else if (!this.require && this.$input.value.trim().length === 0) {
      this.setMassageValid();
    } else if (!re.test(this.$input.value)) {
      setMassageValid ? this.setMassageValid(this.messages.inputFormat) : null;
      valid = false;
      //ограничение на java - 3584 для текстовых полей
    } else if (this.$input.value.trim().length > 3584) {
      valid = false;
      setMassageValid ? this.setMassageValid(this.messages.inputTextTooLong) : null;
    } else {
      this.setMassageValid();
    }
    return valid;
  }
  validationPhone() {
    let setMassageValid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let valid = true;
    /*
     * 1. Если поле обязательное - выводи ошибку если нет значения
     */
    if (!this.$input.value && this.require) {
      valid = false;
      if (setMassageValid) this.setMassageValid(this.messages.inputRequired);
    }
    if (this.mask_use && this.$input.value) {
      valid = this.$input.value.replace(/\D/g, "").length === this.mask.replace(/\D/g, "").length;
    }
    /*if (this.require && this.$input.value.trim().length === 0) {
      setMassageValid
        ? this.setMassageValid(this.messages.inputRequired)
        : null;
      valid = false;
    } else if (!this.require && this.$input.value.trim().length === 0) {
      this.setMassageValid();
      //ограничение на java - 3584 для текстовых полей
    } else if (this.$input.value.trim().length > 3584) {
      valid = false;
      setMassageValid
        ? this.setMassageValid(this.messages.inputTextTooLong)
        : null;
      //если используется маска для телефона
    }
      if (this.mask_use) {
      valid = this.iMask.unmaskedValue.length === this.mask.replace(/\D/g, '').length
      if (!valid) this.setMassageValid(this.messages.inputFormat)
      //если не используется маска
    } else if (!this.mask_use) {
      //если в значении есть символ +
      if (this.$input.value.match(/\+/g)) {
        //если плюс стоит не в начале строки или плюсов больше одного
        if (
          !/^\+/.test(this.$input.value) ||
          this.$input.value.match(/\+/g).length > 1
        ) {
          setMassageValid
            ? this.setMassageValid(this.messages.inputFormat)
            : null;
          valid = false;
        } else {
          //проверяем на длину значения с учетом добавленных '+7'
          if (
            this.$input.value.trim().length >= 12 &&
            this.$input.value.trim().length <= 18
          ) {
            valid = true;
            this.setMassageValid();
          } else {
            setMassageValid
              ? this.setMassageValid(this.messages.inputFormat)
              : null;
            valid = false;
          }
        }
        //если ввели просто цифры без символов
      } else {
        if (this.$input.value.trim().length < 10) {
          setMassageValid
            ? this.setMassageValid(this.messages.inputFormat)
            : null;
          valid = false;
        } else {
          valid = true;
          this.setMassageValid();
        }
      }
    }*/
    if (!valid && setMassageValid) {
      this.setMassageValid(this.messages.inputFormat);
    } else {
      this.setMassageValid();
    }
    return valid;
  }
  getPrecisionValue() {
    let precision = 0;
    let arr = [];
    let indexDot = this.$input.value.trim().indexOf(".");
    let indexComma = this.$input.value.trim().indexOf(",");
    if (indexDot !== -1) {
      arr = this.$input.value.trim().split(".");
    }
    if (indexComma !== -1) {
      arr = this.$input.value.trim().split(",");
    }
    if (arr.length > 1) {
      precision = arr[1].length;
    }
    return precision;
  }
  validationNumber() {
    let setMassageValid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let re = new RegExp("^[-+]?[0-9]*[.,]?[0-9]+(?:[eE][-+]?[0-9]+)?$");
    let valid = true;
    if (this.require && !this.$input.value) {
      setMassageValid ? this.setMassageValid(this.messages.inputRequired) : null;
      valid = false;
    } else if (!this.require && this.$input.value.trim().length === 0) {
      this.setMassageValid();
      //ограничение на java - 3584 для текстовых полей
    } else if (this.$input.value.trim().length > 3584) {
      valid = false;
      setMassageValid ? this.setMassageValid(this.messages.inputTextTooLong) : null;
    } else if (!re.test(this.$input.value.trim()) && !Number.isNaN(this.$input.value.trim())) {
      setMassageValid ? this.setMassageValid(this.messages.inputFormat) : null;
      valid = false;
    } else if (this.precision < this.getPrecisionValue()) {
      setMassageValid ? this.setMassageValid(this.messages.inputFormat) : null;
      valid = false;
    } else if (Number(this.$input.value) < this.options.min || Number(this.$input.value) > this.options.max) {
      valid = false;
      this.setMassageValid(this.messages.inputBetween.replace("{0}", this.options.min).replace("{1}", this.options.max));
    } else {
      this.setMassageValid();
    }
    return valid;
  }
  validation() {
    let setMassageValid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (this.typeId) {
      let valid = this[TYPE_POLICY[this.typeId].validationNameFn](setMassageValid);
      //если условие верно - поле валидно, и в нем есть данные, граница становится зеленой
      this.setSuccessValid(valid && this.$input.value.length);
      return valid;
    } else {
      return false;
    }
  }
  onPaste() {
    this.validation(false);
  }
  destroy() {
    this.iMask?.destroy();
    super.destroy();
  }
}